<template>
    <Transition name="modal-backdrop" appear>
      <div v-if="isOpen" class="fixed inset-0 z-50 overflow-y-auto">
        <!-- Backdrop -->
        <div class="fixed inset-0 bg-black/25" @click="close" />
        
        <!-- Modal Container -->
        <div class="flex items-center justify-center min-h-full p-4">
          <Transition name="modal-content" appear>
            <div
              v-if="isOpen"
              :class="{
                'mt-20 w-full md:w-[416px]': size === 'sm',
                'mt-20 w-full md:w-[518px]': size === 'md',
                'mt-10 w-full md:w-[590px]': size === 'lg',
                'mt-10 w-full md:w-[680px]': size === 'xl',
                'mt-10 w-full lg:w-[960px]': size === 'xxl',
                'mt-10 min-h-[calc(100vh-56px)] w-full bg-gray-100 md:min-h-[calc(100vh-64px)]': size === 'full',
              }"
              class="my-8 inline-block overflow-hidden rounded-[4px] bg-white text-left align-middle shadow-xl relative z-10"
              @click.stop
            >
              <!-- Header -->
              <div
                class="flex items-center justify-between rounded-t-[4px] pb-[12px] pl-6 pt-4 text-lg leading-normal text-gray-600"
                :class="{
                  'border-b border-gray-200 bg-gray-50': grayHeader,
                }"
              >
                <div class="truncate">
                  <slot name="header"></slot>
                </div>
                <button
                type="button"
                  data-testid="modal-close-button"
                  class="mr-6"
                  @click="close"
                >
                  <XMarkIcon class="w-6 h-6 text-gray-500 hover:text-gray-700" />
                </button>
              </div>

              <slot name="body"></slot>
              <slot name="footer"></slot>
            </div>
          </Transition>
        </div>
      </div>
    </Transition>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  size: {
    validator(val) {
      return ['sm', 'md', 'lg', 'xl', 'xxl', 'full'].includes(val);
    },
    default: 'md',
  },
  grayHeader: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(['close', 'clicked']);

onMounted(() => {
    isOpen.value = true;
});

const isOpen = ref(false);

const close = () => {
  isOpen.value = false;

  setTimeout(() => {
    emit('close');
  }, 200);
};

</script>

<style scoped>
/* Backdrop transitions */
.modal-backdrop-enter-active,
.modal-backdrop-leave-active {
  transition: opacity 0.3s ease;
}

.modal-backdrop-enter-from,
.modal-backdrop-leave-to {
  opacity: 0;
}

/* Content transitions */
.modal-content-enter-active {
  transition: all 0.3s ease;
}

.modal-content-leave-active {
  transition: all 0.2s ease;
}

.modal-content-enter-from {
  opacity: 0;
  transform: scale(0.95);
}

.modal-content-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>